
import { useNavigate } from 'react-router-dom';
import { validatePasswordMatch } from 'units/auth/utils/validation';
import { useEffect, useState } from "react";
import feather from 'feather-icons';
import { showToast } from 'toast/toastHelper';
import { useDispatch, useSelector } from 'react-redux';
import { PulseLoader } from 'react-spinners';
import Footer from 'units/dashboard/components/Footer';
import { changePassword } from 'units/auth/services/authService';
import AdminSidebar from './components/AdminSidebar';
import Header from 'units/dashboard/components/Header';
const AdminChangePassword = () => {
    const [formData, setFormData] = useState({

        oldPassword: "",
        newPassword: '',
        confirmNewPassword: ''
    });
    const [error, setError] = useState("");
    const [successMessage, setSuccessMessage] = useState("");
    const [loading, setLoading] = useState(false)
    const accessToken = useSelector((state => state.auth.accessToken))
    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        feather.replace();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        const passwordRegex = /^[\u0600-\u06FFa-zA-Z0-9۰-۹!@#$%^&*()_+=\-{}\[\]:;"'<>,.?/\\|~`]*$/;
        if (value === "" || passwordRegex.test(value)) {
            setFormData((prevData) => ({
                ...prevData,
                [name]: value,
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true)
        setError("");
       
        setSuccessMessage("");
        try {
            const validationError = validatePasswordMatch(formData.newPassword, formData.confirmNewPassword);
            if (validationError) {
                setError(validationError);
                setLoading(false);
                return;
            }
            const res = await changePassword({
                accessToken,
                oldPassword: formData.oldPassword,
                password: formData.newPassword,
                confirmPassword: formData.confirmNewPassword
            });
            if (res?.ok) {
                setSuccessMessage("رمز عبور با موفقیت تغییر یافت.");
                showToast("تغییر رمز با موفقیت انجام شد.", "success")
                setFormData({
                    oldPassword: "",
                    newPassword: "",
                    confirmNewPassword: ""
                });
            }

        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    };

    return (
        <div className="">

            <nav
                className="border-b border-slate-100 dark:bg-zinc-800 print:hidden flex items-center fixed top-0 right-0 left-0 bg-white z-10 dark:border-zinc-700">
                <Header/>
            </nav>

            <div
                className="vertical-menu rtl:right-0 fixed ltr:left-0 bottom-0 top-16 h-screen border-r bg-slate-50 border-gray-50 print:hidden dark:bg-zinc-800 dark:border-neutral-700 z-10">
                <AdminSidebar/>
            </div>
            <div className="flex flex-col min-h-screen mt-4">
                <div className="main-content flex-grow pt-16 pb-12">
                    
                    <div className="min-h-screen flex flex-row-reverse items-center justify-center px-2 md:px-8">
                        
                        <div className="max-w-lg w-full m-auto">
                            <div className="p-8 rounded-2xl  shadow-md pt-1 m-auto">
                                <h2 className="text-gray-600 text-center text-2xl mt-[-70px] font-bold"> تغییر رمز حساب کاربری</h2>
                                <form className="mt-5 space-y-5" onSubmit={handleSubmit}>
                                    <div>
                                        <label className="text-gray-600 text-sm mb-2 block"> رمز عبور </label>
                                        <input
                                            name="oldPassword"
                                            type="password"
                                            required
                                            value={formData.oldPassword}
                                            onChange={handleChange}
                                            className="w-full text-gray-600 text-sm border border-[#aadec5] px-4 py-3 rounded-md outline-[#8bedbe] focus:ring-1 focus:ring-[#8bedbe]"
                                            placeholder="رمز عبور فعلی را وارد کنید."
                                        />
                                    </div>

                                    <div>
                                        <label className="text-gray-600 text-sm mb-2 block"> رمز عبور جدید</label>
                                        <input
                                            name="newPassword"
                                            type="password"
                                            required
                                            value={formData.newPassword}
                                            onChange={handleChange}
                                            className="w-full text-gray-800 text-sm border border-[#aadec5] px-4 py-3 rounded-md outline-[#8bedbe] focus:ring-1 focus:ring-[#8bedbe]"
                                            placeholder="رمز عبور جدید را وارد کنید"
                                        />
                                    </div>
                                    <div>
                                        <label className="text-gray-600 text-sm mb-2 block"> تکرار رمز عبور جدید</label>
                                        <input
                                            name="confirmNewPassword"
                                            type="password"
                                            required
                                            value={formData.confirmNewPassword}
                                            onChange={handleChange}
                                            className="w-full text-gray-800 text-sm border border-[#aadec5] px-4 py-3 rounded-md outline-[#8bedbe] focus:ring-1 focus:ring-[#8bedbe]"
                                            placeholder="رمز عبور را وارد کنید"
                                        />
                                    </div>

                                    {error && <p className="text-red-600 text-sm">{error}</p>}
                                    {successMessage && <p className="text-green-600 text-sm">{successMessage}</p>}

                                    <div className="mt-8">
                                        <button
                                            type="submit"
                                            className="w-full py-2 px-4 text-lg tracking-wide rounded-lg text-gray-700 bg-[#aadec5] hover:bg-[#8bedbe] focus:outline-none"
                                            disabled={loading}
                                        >
                                            {!loading ? "تغییر رمز عبور" : <PulseLoader
                                                color="#f2f1f1"
                                                size={9}
                                            />}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default AdminChangePassword;
